<template>
    <section
        class="fold"
        v-on="$listeners"
    >
        <slot />
    </section>
</template>

<script>
export default {
    name: 'Fold',
};
</script>

<style>
    .fold {
        width: 50px;
        height: 191px;
        position: fixed;
        right: -3px;
        top: 20%;
        line-height: 800px;
        overflow: hidden;
        cursor: pointer;
        z-index: 10;
    }
</style>
